"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMatch = void 0;

var _all = require("../all/all");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var byValue = function byValue(_ref) {
  var shouldBe = _ref.shouldBe,
      value = _ref.value,
      not = _ref.not;
  return not ? shouldBe !== value : shouldBe === value;
};

var byFn = function byFn(_ref2) {
  var shouldBe = _ref2.shouldBe,
      value = _ref2.value,
      not = _ref2.not;
  var result = shouldBe(value) === true;
  return not ? !result : result;
};
/**
 * Determines if one object's properties are equal to another
 *
 * @name   isMatch
 * @tag Core
 * @signature (subset: Object)(source: Object): boolean
 *
 * @param  {Object}   subset  Set of properties that should match
 * @param  {Object}   source  Object matching against
 *
 * @return {boolean}  True if all "subset" properties are of equal (shallow
 *                    compare) value to properties in "source" object,
 *                    otherwise false
 *
 * @example
 * isMatch({
 *  id: 2,
 *  parentId: null,
 * })({
 *  id: 2,
 *  parentId: null
 *  name: "John",
 * })
 * // true
 *
 * isMatch({
 *  "!parentId": null,
 *  "name": "John",
 * })({
 *  id: 2,
 *  parentId: null,
 *  name: "John",
 * })
 * // false
 */


var isMatch = function isMatch(subset) {
  return function (source) {
    return (0, _all.all)(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          shouldBe = _ref4[1];

      var shouldTestNegation = key[0] === "!";
      var sourceKey = key.replace("!", "");
      var value = source[sourceKey];
      return typeof shouldBe === "function" ? byFn({
        shouldBe: shouldBe,
        value: value,
        not: shouldTestNegation
      }) : byValue({
        shouldBe: shouldBe,
        value: value,
        not: shouldTestNegation
      });
    })(Object.entries(subset));
  };
};

exports.isMatch = isMatch;